/**
 * Format value in dollars
 *
 * @param  {*} value Value to format in USD
 *
 * @returns {string} Formatted string
 */
export default (value, { withFraction = true } = {}) => {
    const amount = value / 100;

    if ('number' !== typeof amount) {
        return amount;
    }

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        ...(withFraction || 0 !== amount % 1
            ? {
                minimumFractionDigits: 2,
            }
            : {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }
        ),
    });

    return formatter.format(amount);
};
